module.exports = __webpack_public_path__ + "static/img/info.e8763798.svg";